module.exports = __webpack_public_path__ + "img/coments-white.a33f4a9f.svg";